module.exports = __webpack_public_path__ + "img/_china.9dc517ac.png";